import { subscriptionPlanMapper } from '../mappers/subscription-plan-mapper';
import { safeStorage } from '../shared/safe-storage';

const purchaseRepository = {
    get() {
        const data = safeStorage.getItem('purchase_data');
        const parsed = data ? JSON.parse(data) : {};

        return {
            ...parsed,
            planName: subscriptionPlanMapper.getPlanName(parsed.plan)
        };
    },

    saveSubscription(subscriptionId, plan, discount) {
        const data = purchaseRepository.get();

        safeStorage.setItem('purchase_data', JSON.stringify({ ...data, subscriptionId, plan, discount }));
    },

    saveProduct(productId) {
        const data = purchaseRepository.get();

        safeStorage.setItem('purchase_data', JSON.stringify({ ...data, productId }));
    }
};

export {
    purchaseRepository
};
